import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Provider } from 'react-redux';
import store from '@/application/redux/store';
import App from '@/routes/index';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from '@/views/styles/normalize';
import { checkTheme } from '@/application/helpers/theme';
import { SidebarProvider } from '@/application/contexts/SidebarContext';
import { ToastContainer } from 'react-toastify';
import { ToastStyles } from '@/lib/toastStyles';
import reportWebVitals from './reportWebVitals';
import '@/application/hooks/i18n';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const themeName = localStorage.getItem('theme') || 'default';
const theme = checkTheme(themeName);
// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <ToastStyles />
          <Provider store={store}>
            <SidebarProvider>
              <App />
              <ToastContainer />
            </SidebarProvider>
          </Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
